import {UPDATE_SELECTED_TAB} from '../actionTypes';

export const tab = (
  state = {
    tabValue: 0,
  },
  action,
) => {
  switch (action.type) {
    case UPDATE_SELECTED_TAB:
      localStorage.setItem('tabValue', action.tabValue);
      return {
        ...state,
        tabValue: action.tabValue,
      };
    default:
      return state;
  }
};
